import React, { useContext, useState, useToggle } from "react";
import { Link, Route, Routes, NavLink } from "react-router-dom";
import profileLogo from "../assets/images/user.png";
import Dashboard from "../pages/Dashboard";
import Notfound from "./Notfound";
import Usersmarttableinlineform from "../pages/Usersmarttableinlineform";
import { AuthContext } from "../context/Authcontext";
import Googlecharts from "./Googlecharts";
import Profile from "../pages/Profile";
import Settings from "../pages/Settings";
import Loader from "./Loader";
import Toastmessage from "./Toastmessage";
import Datatable from "./Datatable";
import authsService from "../services/auths.service";
import Usersmarttablewithform from "../pages/Usersmarttablewithform";
import Usersmarttable from "../pages/Usersmarttable";
import Userevent from "../pages/Userevent";
import Reactcropper from "./Reactcropper";
import Reacteasycrop from "./Reacteasycrop";
import Reactadvcrop from "./Reactadvcrop";
import Reactquill from "./Reactquill";
import Reactpdfrender from "./Reactpdfrender";
import Reactpdfviewer from "./Reactpdfviewer";
import User from "../pages/User";
import Usersmartevent from "../pages/Usersmartevent";
import Category from "../pages/Category";
import Statistics from "../pages/Statistics";
import mylogo from "../assets/images/letscoollogowhite.png";

import Setup from "../pages/Setup";
import Clientsetup from "../pages/Clientsetup";

import Client from "../pages/Client";
import Clientevent from "../pages/Clientevent";
import Airconchecklist from "../pages/Airconchecklist";
import Airconservicing from "../pages/Airconservicing";
import Aircon from "../pages/Aircon";
import Airconunit from "../pages/Airconunit";
import Airconunity from "../pages/Airconunity";

import Airconunitevent from "../pages/Airconunitevent";
import Airconevent from "../pages/Airconevent";
import Technition from "../pages/Technition";
import Technitionevent from "../pages/Technitionevent";
import Airconhistory from "../pages/Airconhistory";
import Airconhistoryy from "../pages/Airconhistoryy";

import Airconhistoryevent from "../pages/Airconhistoryevent";
import Airconlocation from "../pages/Airconlocation";
import Airconhistorystatus from "../pages/Airconhistorystatus";
import Preventivemaintenance from "../pages/Preventivemaintenance";
import Pendingcase from "../pages/Pendingcase";
import Usersmarttablewithmodal from "../pages/Usersmarttablewithmodal";
import Airconview from "../pages/Airconview";
import Principalevent from "../pages/Principalevent";

import Qrcode from "./Qrcode";
import Airconqrcode from "../pages/Airconqrcode";
import Reactsignatureconvas from "./Reactsignatureconvas";
import Reports from "../pages/Reports";
import Jspdfrender from "./Jspdfrender";
import Jspdfrenderqrcode from "./Jspdfrenderqrcode";

const Dashboardlayout = () => {
  /* const userinfo = authsService.userinfo(); */
  const userinfo = authsService.userinfo();
  const { signOut } = useContext(AuthContext);

  const togglemenu = () => {
    let sidebar = document.querySelector(".sidebar");
    let sidebarBtn = document.querySelector(".sidebarBtn");
    sidebar.classList.toggle("active");
    if (sidebar.classList.contains("active")) {
      sidebarBtn.classList.replace("fa-bars", "fa-align-left");
    } else sidebarBtn.classList.replace("fa-align-left", "fa-bars");
  }; /* <i className="fa fa-bars" aria-hidden="true"></i> */
  return (
    <div className="dashboard-layout-container">
      <div className="sidebar">
        <a  className="btn closetoggl" style={{ position: "absolute",color:"white", right: 0,padding:6, }} onClick={togglemenu}>X</a>
        <div className="logo-details ps-3">
          {/* <i className='bx bxl-c-plus-plus'></i> */}
          {/* <i className="fa fa-ravelry" aria-hidden="true"></i> */}
          <img
            className=""
            style={{ width: 40, height: 40 }}
            src={mylogo}
            onError={({ currentTarget }) => {
              currentTarget.onerror = null;
              currentTarget.src = { mylogo };
            }}
            alt=""
          />
          <span className="logo_name ps-3">LETSCOOL</span>
        </div>
        <div
          style={{
            marginTop: -30,
            paddingLeft: 72,
            whiteSpace: "nowrap",
            fontSize: 10,
          }}
          className=" logo_name text-light"
        >
          <small>Adhoc maintenance</small>
        </div>
        <ul className="nav-links pt-4">
          <li>
            <NavLink
              to="/"
              className={({ isActive }) =>
                isActive ? "sidebar-nav-active" : "sidebar-nav-links"
              }
            >
              {/*  <i className='bx bx-grid-alt' ></i> */}
              <i className="fa fa-dashboard" aria-hidden="true"></i>
              <span className="links_name">Overview</span>
            </NavLink>
          </li>
         
          <li>
            <NavLink
              to="/pendingcase"
              className={({ isActive }) =>
                isActive ? "sidebar-nav-active" : "sidebar-nav-links"
              }
            >
              <i className="fa fa-bullhorn" aria-hidden="true"></i>
              <span className="links_name">Cases</span>
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/preventivemaintenance"
              className={({ isActive }) =>
                isActive ? "sidebar-nav-active" : "sidebar-nav-links"
              }
            >
              <i className="fa fa-suitcase" aria-hidden="true"></i>
              <span className="links_name">Adhoc maintenance</span>
            </NavLink>
          </li>

          <li>
            <NavLink
              to="/aircon"
              className={({ isActive }) =>
                isActive ? "sidebar-nav-active" : "sidebar-nav-links"
              }
            >
              <i className="fa fa-codiepie" aria-hidden="true"></i>
              <span className="links_name">Aircons </span>
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/client"
              className={({ isActive }) =>
                isActive ? "sidebar-nav-active" : "sidebar-nav-links"
              }
            >
              <i className="fa fa-user-secret" aria-hidden="true"></i>
              <span className="links_name">Clients </span>
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/airconqrcode"
              className={({ isActive }) =>
                isActive ? "sidebar-nav-active" : "sidebar-nav-links"
              }
            >
              <i className="fa fa-qrcode" aria-hidden="true"></i>
              <span className="links_name">Aircon QRCode </span>
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/statistics"
              className={({ isActive }) =>
                isActive ? "sidebar-nav-active" : "sidebar-nav-links"
              }
            >
              <i className="fa fa-area-chart" aria-hidden="true"></i>
              <span className="links_name">Statistics</span>
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/report"
              className={({ isActive }) =>
                isActive ? "sidebar-nav-active" : "sidebar-nav-links"
              }
            >
              <i className="fa fa-file-text" aria-hidden="true"></i>
              <span className="links_name">Reports </span>
            </NavLink>
          </li>
          <div className="sidenav-submenu">
            <a
              className="sidebar-nav-links"
              data-bs-toggle="collapse"
              href="#sidenavcollapese1"
              aria-expanded="false"
              aria-controls="collapseExample"
            >
              <i className="fa fa-cog" aria-hidden="true"></i>
              <span className="links_name">Setting </span>
              <span style={{ fontWeight: 700 }} className="ps-4 text-white">
                +{/*   <i className="fa fa-chevron-right"></i> */}
              </span>
            </a>
            <div className="collapse sidenavcollapese" id="sidenavcollapese1">
              <NavLink
                to="/user"
                className={({ isActive }) =>
                  isActive ? "sidebar-nav-active" : "sidebar-nav-links"
                }
              >
                <i className="fa fa-lock" aria-hidden="true"></i>
                <span className="links_name">User</span>
              </NavLink>
              <NavLink
                to="/technition"
                className={({ isActive }) =>
                  isActive ? "sidebar-nav-active" : "sidebar-nav-links"
                }
              >
                <i className="fa fa-user" aria-hidden="true"></i>
                <span className="links_name">Technician</span>
              </NavLink>
              {/*  <NavLink
                to="/usersmarttable"
                className={({ isActive }) =>
                  isActive ? "sidebar-nav-active" : "sidebar-nav-links"
                }
              >
                <i className="fa fa-table" aria-hidden="true"></i>
                <span className="links_name">smart table</span>
              </NavLink>
              <NavLink
                to="/usersmarttablewithform"
                className={({ isActive }) =>
                  isActive ? "sidebar-nav-active" : "sidebar-nav-links"
                }
              >
                <i className="fa fa-tags" aria-hidden="true"></i>
                <span className="links_name">usersmarttablewithform</span>
              </NavLink>
              <NavLink
                to="/usersmarttableinlineform"
                className={({ isActive }) =>
                  isActive ? "sidebar-nav-active" : "sidebar-nav-links"
                }
              >
                <i className="fa fa-tags" aria-hidden="true"></i>
                <span className="links_name">usersmarttableinlineform</span>
              </NavLink> */}
              <NavLink
                to="/setup"
                className={({ isActive }) =>
                  isActive ? "sidebar-nav-active" : "sidebar-nav-links"
                }
              >
                <i className="fa fa-crosshairs" aria-hidden="true"></i>
                <span className="links_name">Setup</span>
              </NavLink>
            </div>
          </div>
          <li>
            <NavLink
              to="/sd"
              className={({ isActive }) =>
                isActive ? "sidebar-nav-active" : "sidebar-nav-links d-none"
              }
            >
              {/*  <i className='bx bx-cog' ></i> */}
              <i className="fa fa-cog" aria-hidden="true"></i>
              <span className="links_name">Setting</span>
            </NavLink>
          </li>
        </ul>
      </div>
      <section className="home-section">
        <nav>
          <div onClick={togglemenu} className="sidebar-button">
            {/*  <i className='bx bx-menu sidebarBtn'></i> */}
            <i className="fa fa-bars sidebarBtn" aria-hidden="true"></i>
            <span className="dashboard"></span>
          </div>
          <div className="notify-details">
            {/*  <a href='#'><i className="fa fa-bell" aria-hidden="true"></i></a> */}
            <a href="#" className="notification-container">
              <i className="fa fa-envelope" aria-hidden="true"></i>
              <span className="notification-counter">3</span>
            </a>
            <a href="#" className="notification-container">
              <i className="fa fa-bell" aria-hidden="true"></i>
              <span className="notification-counter">1</span>
            </a>
          </div>
          <div className="profile-details">
            {/* <img src="images/profile.jpg" alt="" /> */}
            <div className="dropdown">
              <a type="button" data-bs-toggle="dropdown" aria-expanded="false">
                <img
                  src={profileLogo}
                  onError={({ currentTarget }) => {
                    currentTarget.onerror = null;
                    currentTarget.src = { profileLogo };
                  }}
                  alt=""
                />
                <span className="admin_name ">{userinfo.user_name}</span>
                {/*  <i className="fa fa-chevron-down"></i> */}
              </a>
              <ul className="dropdown-menu mt-1">
                <li>
                  <NavLink to="/profile" className="dropdown-item">
                    {/* <i className='bx bx-log-out'></i> */}
                    Profile
                  </NavLink>
                </li>
                {/* <li>
                  <NavLink to="/settings" className="dropdown-item">
                    <i className='bx bx-log-out'></i>
                    Setting
                  </NavLink>
                </li> */}
                <li className="">
                  <a role="button" onClick={signOut} className="dropdown-item">
                    Logout
                    <span className="ps-3">
                      {" "}
                      <i className="fa fa-sign-out" aria-hidden="true"></i>
                    </span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </nav>

        <div className="home-content">
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route
              path="usersmarttableinlineform"
              element={<Usersmarttableinlineform />}
            />
            <Route
              path="usersmarttablewithform"
              element={<Usersmarttablewithform />}
            />
            <Route
              path="usersmarttablewithmodal"
              element={<Usersmarttablewithmodal />}
            />
            <Route path="usersmarttable" element={<Usersmarttable />} />
            <Route path="usersmartevent" element={<Usersmartevent />} />

            <Route path="reactcropper" element={<Reactcropper />} />
            <Route path="reactquill" element={<Reactquill />} />
            <Route path="reactpdfrender" element={<Reactpdfrender />} />
            <Route path="reactpdfviewer" element={<Reactpdfviewer />} />
            <Route path="qrcode" element={<Qrcode />} />
            <Route path="airconqrcode" element={<Airconqrcode />} />
            <Route path="signature" element={<Reactsignatureconvas />} />


            <Route path="reacteasycrop" element={<Reacteasycrop />} />
            <Route path="reactadvcrop" element={<Reactadvcrop />} />
            <Route path="statistics" element={<Statistics />} />
            <Route path="report" element={<Reports />} />
            <Route path="jspdfrender" element={<Jspdfrender />} />
            <Route path="jspdfrenderqrcode" element={<Jspdfrenderqrcode />} />



            <Route path="googlechart" element={<Googlecharts />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/loader" element={<Loader />} />
            <Route path="/toastmessage" element={<Toastmessage />} />
            <Route path="/datatable" element={<Datatable />} />
            <Route path="/setup" element={<Setup />} />
            <Route path="/clientsetup" element={<Clientsetup />} />

            <Route path="user" element={<User />} />
            <Route path="userevent" element={<Userevent />} />
            <Route path="client" element={<Client />} />
            <Route path="clientevent" element={<Clientevent />} />
            <Route path="principalevent" element={<Principalevent />} />

            <Route path="category" element={<Category />} />
            <Route path="checklist" element={<Airconchecklist />} />
            <Route path="servicing" element={<Airconservicing />} />
            <Route path="aircon" element={<Aircon />} />
            <Route path="airconunit" element={<Airconunit />} />
            <Route path="airconunity" element={<Airconunity />} />

            <Route path="airconunitevent" element={<Airconunitevent />} />

            <Route path="airconevent" element={<Airconevent />} />
            <Route path="technition" element={<Technition />} />
            <Route path="technitionevent" element={<Technitionevent />} />
            <Route path="airconhistory" element={<Airconhistory />} />
            <Route path="airconhistoryy" element={<Airconhistoryy />} />
            <Route path="airconview" element={<Airconview />} />

            <Route path="airconhistoryevent" element={<Airconhistoryevent />} />
            <Route path="location" element={<Airconlocation />} />
            <Route
              path="airconhistorystatus"
              element={<Airconhistorystatus />}
            />
            <Route
              path="preventivemaintenance"
              element={<Preventivemaintenance />}
            />
            <Route path="pendingcase" element={<Pendingcase />} />

            <Route path="*" element={<Notfound />} />
          </Routes>
        </div>
      </section>
    </div>
  );
};

export default Dashboardlayout;
